import { Component, Inject, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { LoaderService } from '../../shared/loader/loader.service';
import { StatusConstant } from '../status/status-constant';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-addDocumentEmails',
  templateUrl: './addDocumentEmails.component.html',
  styleUrls: ['./addDocumentEmails.component.scss']
})

export class AddDocumentEmailsComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any = [] = [];
  spinner: boolean = false;
  OfficeIDList: any = [] = [];
  myOfficeID: any;
  emails: string = "";
  folderID: number = 0;
  isEmailAssociated: boolean = false;
  folderEmailID: number = 0;
  folderName:string="";

  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<AddDocumentEmailsComponent>,
    private encryptionAlgo: EncryptionService, private settingsService: SettingService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    private loaderService: LoaderService, private statusConst: StatusConstant,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }


  ngOnInit(): void {
    this.folderName = this.data.folderName;
    this.isEmailAssociated=this.data.isEmailAssociated;
    if(this.data.isEmailAssociated==true){
      this.GetEmailForFolder();
    }
  }
 
  GetEmailForFolder() {
    var ReqModel = {     
      folderID: this.data.folderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }    
    this.settingsService.getEmailForFolder(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.emails= this.responseHolder.data.email ?? "";
          this.emails = this.emails.replace("@inbound.flowtrics.com", "");
          this.folderEmailID =this.responseHolder.data.folderEmailID ?? 0;
        } else {
         this.emails="";
        }
      } else {
        this.emails="";
      }
    });
  }

  acceptEmail() {
    var ReqModel = {
      email: this.emails + '@inbound.flowtrics.com',
      folderID: this.data.folderID,
      folderEmailID: this.folderEmailID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.loaderService.show();
    this.settingsService.addEmailForSyncFile(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
         this.loaderService.hide();
        if (this.responseHolder.data >0) {
          this.loaderService.hide();
          this.dialogRef.close('Added');
          this.toastr.success("Email added successfully.", '', {
            timeOut: 3000,
          });
        }
        if (this.responseHolder.data==0) {
           this.loaderService.hide();
           this.toastr.error("Error occurred.", '', {
            timeOut: 3000,
          });
        }
         if (this.responseHolder.data==-1) {
           this.loaderService.hide();
           this.toastr.warning("This email address is already associated with another office. Please use a different email address.", '', {
            timeOut: 6000,
          });
        }
        // else {
        //   this.loaderService.hide();
        // }
      } else {
        this.loaderService.hide();
      }
    });
  }

  close() {
    this.emails = "";
    this.dialogRef.close();
  }

   emailDelete() {
      const message = `Are you sure you want to delete this email?`;
      const title = `Confirm Delete`;
      const confirm = `Delete`;
      const dialogData = new ConfirmDialogModel(title, message, confirm);    
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData,
      });
  
      dialogRef.beforeClosed().subscribe(async (dialogResult) => {
        try {
          if (dialogResult) {
             var ReqModel = {     
              folderEmailID: this.folderEmailID,
              userID: this.currentUser.UID,
              organizationID: Number(this.organizationId),
              officeID: Number(this.myOfficeID),
              officeIDList: this.OfficeIDList,
              databaseID: Number(this.databaseId)
            }   
            this.loaderService.show();
            this.settingsService.deleteEmailForSyncFile(ReqModel).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                if (this.responseHolder.status == this.statusConst.statusSuccess) {                 
                  this.loaderService.hide();
                  this.dialogRef.close('Added');
                  this.toastr.success('Email deleted successfully.', '', {
                    timeOut: 3000,
                  });
                } else {
                  this.loaderService.hide();
                  this.toastr.error('Email deletion failed.', '', {
                    timeOut: 3000,
                  });
                }
              } else {
                this.loaderService.hide();
                this.toastr.error('Email deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            });
          }
        } catch (e) {
          Observable.throw(e);
        }
      });
   }

   copyEmail() {
  const email = `${this.emails}@inbound.flowtrics.com`;

  navigator.clipboard.writeText(email).then(() => {
    // Optional
     this.toastr.success('Email copied');
  });
}

allowEmailChars(event: KeyboardEvent): void {
  const input = event.target as HTMLInputElement;
  const char = event.key;

  // Allow control keys
  if (event.ctrlKey || event.metaKey || char.length > 1) {
    return;
  }

  // Allow only letters, numbers, dot and underscore
  if (!/^[A-Za-z0-9._]$/.test(char)) {
    event.preventDefault();
    return;
  }

  // Allow only one dot
  if (char === '.' && input.value.includes('.')) {
    event.preventDefault();
    return;
  }

  // Allow only one underscore
  if (char === '_' && input.value.includes('_')) {
    event.preventDefault();
  }
}

onPasteEmail(event: ClipboardEvent): void {
  const pastedText = event.clipboardData?.getData('text') || '';
  const input = event.target as HTMLInputElement;

  const start = input.selectionStart ?? 0;
  const end = input.selectionEnd ?? 0;

  const newValue =
    input.value.substring(0, start) +
    pastedText +
    input.value.substring(end);

  if (!/^[A-Za-z0-9._]+$/.test(pastedText)) {
    event.preventDefault();
    return;
  }

  const dotCount = (newValue.match(/\./g) || []).length;
  const underscoreCount = (newValue.match(/_/g) || []).length;

  if (dotCount > 1 || underscoreCount > 1) {
    event.preventDefault();
  }
}

}
